import { RecommendedDataType } from '../../../product-data';
import {
  getBrandOrganisation,
  BrandOrgType,
} from '../bought-this-season/brand-org';
import { createApiRequestPayloadPropertiesProvider } from '../products-on-the-way/products-on-the-way-helpers';
import { getDataFromRecommendations } from './get-products-on-the-way';
import {
  daysIntoTheFutureProvider,
  shipToAddressIdProvider,
} from './products-on-the-way-days-into-future-provider';

const LOOK_AHEAD_CONSTANTS = {
  // accountId: {
  //   provider: 'GlobalStoreProviderService',
  //   property: {
  //     path: 'accounts.activeAccount.accountId',
  //   },
  // },
  brandOrganisation: getBrandOrganisation(),
  brandId: {
    provider: 'self',
    property: 'brandOrganisation',
    transform: function (brandOrg: BrandOrgType): string {
      return brandOrg.brandId;
    }.toString(),
  },
  apiRequestPayloadPropertiesProvider:
    createApiRequestPayloadPropertiesProvider({
      daysIntoTheFuture: {
        provider: 'id:root',
        property: 'selectedDayRange',
      },
      daysIntoThePast: {
        provider: 'id:root',
        property: 'daysIntoThePast',
      },
      shipToAddressId: {
        provider: 'id:root',
        property: 'selectedShipTo',
      },
      filterMissingImages: {
        provider: 'id:root',
        property: 'filterMissingImages',
      },
      brandId: {
        provider: 'id:root',
        property: 'brandId',
      },
    }),
  recommendationsData: getDataFromRecommendations(),
  productData: {
    provider: 'self',
    property: 'recommendationsData',
    transform: function (data: any): any[] {
      if (
        window.neoclesDynamicFramework.recommendationsPanels.methods.isResolveValueError(
          data,
        )
      ) {
        throw new Error(
          'Expected products but encountered an error: ' +
            data.__resolveValueError__,
        );
      }
      return data;
    }.toString(),
  },
  servingConfig: {
    provider: 'self',
    property: 'recommendationsData',
    transform: function (data: RecommendedDataType) {
      return data.servingConfig;
    }.toString(),
  },
};

export const LOOK_AHEAD_PROVIDERS_PROPERTIES = {
  daysIntoThePast: 7,
  filterMissingImages: false,
  hasHeaderFilters: false, // TODO: move away
  showOrdinalSuffix: true,
  showProductSizesPopover: true,
  showDeliveryDateLabel: true,
  selectedDayRange: daysIntoTheFutureProvider,
  selectedShipTo: shipToAddressIdProvider,
  ...LOOK_AHEAD_CONSTANTS,
};
